<script>
import Layout from "../../layouts/main";
import CampaignContent from "@/components/campaignContent";

export default {
  page: {
    title: "Campaign",
  },
  components: {
    CampaignContent,
    Layout,
  },
  data() {
    return {
    };
  },
  computed: {
    campaign() {
      return this.$store.state.campaign.campaigns.find(campaign => campaign._id === this.$route.params.id)
    },
  },
};
</script>

<template>
  <Layout>
    <campaign-content :campaign="campaign"></campaign-content>
  </Layout>
</template>
